import { Component, OnInit, ViewChild } from "@angular/core";
import { GraphQLClient } from '../../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { banco } from '../../../shared/object/banco.model';
import { cuenta_bancaria } from '../../../shared/object/cuenta_bancaria.model';
import { cuenta_bancariaJoin } from '../../../shared/object/cuenta_bancariaJoin.model';
import { SecurityService } from '../../../shared/services/security.service';
import { tipo_cuenta_bancaria } from 'src/app/shared/object/tipo_cuenta_bancaria.model';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';


@Component({
  selector: "app-cuentas-bancarias-empresa",
  templateUrl: "./cuentas-bancarias-empresa.component.html",
  styleUrls: ["./cuentas-bancarias-empresa.component.scss"],
  providers: [SecurityService, ValidadoresService]
})
export class CuentasBancariasEmpresaComponent implements OnInit {
  private client: GraphQLClient = null;
  formulario: FormGroup;
  cuenta_bancariaJoinList: cuenta_bancariaJoin[];
  bancoList: banco[];
  tipo_cuentaList: tipo_cuenta_bancaria[];
  public rut_empresa;
  optionsBanco: Array<any> = [];
  optionsTipoCuenta: Array<any> = [];
  selectedCuentaBancaria: cuenta_bancaria;
  public nombre:string;
  @ViewChild('agregarCuentaBancaria', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarCuentaBancaria', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 37;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());

  constructor(client: GraphQLClient, 
    private formBuilder: FormBuilder, 
    public validadores: ValidadoresService,
    private accesolocalstorage: SecurityService,
    ){
    this.client = client;
    this.buildForm();
  }

  ngOnInit() {
    this.selectedCuentaBancaria = {
      empresa_rut: null,
      tipo_cuenta_bancaria_codigo:null,
      banco_codigo:null,
      numero_cuenta:'',
      observaciones:'',
      activo:true
    };
    this.obtenerDatosCuentaBacarias();
    this.obtenerTipoCuenta();
    this.obtenerBanco();
  }
  
  buildForm() {
    this.formulario = this.formBuilder.group({
      tipo_cuenta: ['', [Validators.required]],
      banco: ['', [Validators.required]],
      numero_cuenta: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
      observaciones: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(200)]],
      activo: [true]
    });
  }

  showNew() {
    this.formulario.reset();
    this.formulario.get('numero_cuenta').enable();
    this.formulario.get('activo').setValue(true);
  }

  showForEdit(cuenta_bancariaJoin: cuenta_bancariaJoin) {
    this.formulario.get('numero_cuenta').setValue(cuenta_bancariaJoin.numero_cuenta);
    this.formulario.get('numero_cuenta').disable();
    this.formulario.get('observaciones').setValue(cuenta_bancariaJoin.observaciones);
    this.formulario.get('activo').setValue(cuenta_bancariaJoin.activo);
    this.obtenerTipoCuentaxCuenta(cuenta_bancariaJoin.tipo_cuenta_bancaria_codigo);
    this.obtenerBancoxCuenta(cuenta_bancariaJoin.banco_codigo);
  }

  obtenerDatosCuentaBacarias() {
    let self = this;
    self.rut_empresa = self.accesolocalstorage.getRutEmpresa(); 
    this.client.query({
      query: gql`
      query($empresa_rut:Decimal){
        cuenta_bancaria{
          obtenerTodosBancoxEmpresa(empresa_rut:$empresa_rut){
            respuesta{
              registros
              {
                empresa_rut
                tipo_cuenta_bancaria_codigo
                nombre_tipo_cuenta
                banco_codigo
                nombre_banco
                numero_cuenta
                observaciones
                activo
              }
            }
          }
        }
      }
      `,
      variables: {
        'empresa_rut': self.rut_empresa,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      self.cuenta_bancariaJoinList = respuesta.data.cuenta_bancaria.obtenerTodosBancoxEmpresa.respuesta.registros;
    });
  }

  obtenerTipoCuenta() {
    let self = this;
    this.client.query({
      query: gql`
        query{
          tipo_cuenta_bancaria{
            obtenerTodos{
              respuesta{
                registros{
                  codigo
                  nombre
                  activado
                }
              }
            }
          }
        }
        `,
      fetchPolicy: 'network-only',
    }, function (respuesta) {
      self.tipo_cuentaList = respuesta.data.tipo_cuenta_bancaria.obtenerTodos.respuesta.registros;
      self.optionsTipoCuenta = [];
      var sel: any;
      self.tipo_cuentaList.forEach(element => {
        if (element.activado == true) {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsTipoCuenta.push(sel);
        }
      });
    });
  }

  obtenerBanco() {
    let self = this;
    this.client.query({
      query: gql`
      query{
        banco{
          obtenerTodos{
            respuesta{
              registros{
                codigo
                nombre
                activado
              }
            }
          }
        }
      }
        `
      ,
      fetchPolicy: 'network-only',
    }, function (respuesta) {
      self.bancoList = respuesta.data.banco.obtenerTodos.respuesta.registros;
      self.optionsBanco= [];
      var sel: any;
      self.bancoList.forEach(element => {
        if (element.activado == true) {
          sel = { value: element.codigo, label: element.nombre };
          self.optionsBanco.push(sel);
        }
      });
    });
  }

  obtenerTipoCuentaxCuenta(codigo:number) {
    let self = this;
    var bodyx: tipo_cuenta_bancaria = new tipo_cuenta_bancaria();
    bodyx.codigo = codigo;
    this.client.query({
      query: gql`
        query($entidad:tipo_cuenta_bancariaInputType){
          tipo_cuenta_bancaria{
            obtenerSegunId(entidad:$entidad){
              respuesta{
                codigo
                nombre
                activado
              }
            }
          }
        }
        `,
        variables: {
          'entidad': bodyx,
        },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      if(respuesta.data.tipo_cuenta_bancaria.obtenerSegunId.respuesta != undefined){
        let tipo_cuenta_codigo = respuesta.data.tipo_cuenta_bancaria.obtenerSegunId.respuesta.codigo;
        self.formulario.controls["tipo_cuenta"].setValue(tipo_cuenta_codigo);
      }else{
        self.formulario.controls["tipo_cuenta"].setValue('');
      }
    });
  }

  obtenerBancoxCuenta(codigo:number) {
    let self = this;
    var bodyx: banco = new banco();
    bodyx.codigo = codigo;
    this.client.query({
      query: gql`
      query($entidad:bancoInputType){
        banco{
          obtenerSegunId(entidad:$entidad){
            respuesta{
              codigo
              nombre
              activado
            }
          }
        }
      }
        `
      ,
      variables: {
        'entidad': bodyx,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      if(respuesta.data.banco.obtenerSegunId.respuesta != undefined){
        let banco_codigo = respuesta.data.banco.obtenerSegunId.respuesta.codigo;
        self.formulario.controls["banco"].setValue(banco_codigo);
      }else{
        self.formulario.controls["banco"].setValue('');
      }
    });
  }

  refrescar(cuenta_bancariaJoin: cuenta_bancariaJoin) {
    let self = this;
    var bodyx = cuenta_bancariaJoin;
    delete cuenta_bancariaJoin.nombre_tipo_cuenta;
    delete cuenta_bancariaJoin.nombre_banco;
    delete cuenta_bancariaJoin["__typename"];
    this.client.mutate({
      mutation: gql`
      mutation($entidad: cuenta_bancariaInputType)
      {
        cuenta_bancaria
        {
          modificar(entidad: $entidad) {
            respuesta{
              empresa_rut
              tipo_cuenta_bancaria_codigo
              banco_codigo
              numero_cuenta
              observaciones
              activo
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.cuenta_bancaria.modificar.respuesta != undefined) {
          self.obtenerDatosCuentaBacarias();
        }
      });
  }

  cambiaEstado(cuenta_bancariaJoin: cuenta_bancariaJoin) {
    if (cuenta_bancariaJoin.activo) {
      cuenta_bancariaJoin.activo = false;
    }
    else {
      cuenta_bancariaJoin.activo = true;
    }
    this.refrescar(cuenta_bancariaJoin);
  }

  ValidaQueExisteDatosCuenta() {
    let self = this; // this is unused
    var cuenta_ban: cuenta_bancaria = new cuenta_bancaria();
    cuenta_ban.empresa_rut= this.accesolocalstorage.getRutEmpresa(); 
    cuenta_ban.tipo_cuenta_bancaria_codigo = this.formulario.controls["tipo_cuenta"].value;
    cuenta_ban.banco_codigo = this.formulario.controls["banco"].value;
    cuenta_ban.numero_cuenta = this.formulario.controls["numero_cuenta"].value;
    this.client.query({
        query: gql`
        query($entidad: cuenta_bancariaInputType){
          cuenta_bancaria{
            existe(entidad:$entidad){
              respuesta
            }
          }
        }
        `,
        fetchPolicy: 'network-only',
        variables: {
          "entidad": cuenta_ban
        },
      },
      function (respuesta) {

        if (respuesta.data.cuenta_bancaria.existe.respuesta) {
          var res = window.confirm("El Numero de cuenta ingresado ya existe. ¿Desea sobreescribirlo?");
          if (res) {
            self.actualizar();
          }
        }
        else {
          self.insertar();
        }
      }
    );
  }

  insertar() {
    this.selectedCuentaBancaria.empresa_rut = this.accesolocalstorage.getRutEmpresa();
    this.selectedCuentaBancaria.tipo_cuenta_bancaria_codigo = this.formulario.controls["tipo_cuenta"].value;
    this.selectedCuentaBancaria.banco_codigo = this.formulario.controls["banco"].value;
    this.selectedCuentaBancaria.numero_cuenta = this.formulario.controls["numero_cuenta"].value;
    this.selectedCuentaBancaria.observaciones = this.formulario.controls["observaciones"].value;
    this.selectedCuentaBancaria.activo = this.formulario.controls["activo"].value;
    this.postCuentaBancaria(this.selectedCuentaBancaria);
  }

  postCuentaBancaria(cuenta_bancaria: cuenta_bancaria) {
    let self = this;
    var bodyx = cuenta_bancaria;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: cuenta_bancariaInputType)
      {
        cuenta_bancaria
        {
          agregar(entidad: $entidad) {
            respuesta{
              empresa_rut
              tipo_cuenta_bancaria_codigo
              banco_codigo
              numero_cuenta
              observaciones
              activo
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.cuenta_bancaria.agregar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosCuentaBacarias(), 1000);
        }
      });
  }

  actualizar() {
    this.selectedCuentaBancaria.empresa_rut = this.accesolocalstorage.getRutEmpresa();
    this.selectedCuentaBancaria.tipo_cuenta_bancaria_codigo = this.formulario.controls["tipo_cuenta"].value;
    this.selectedCuentaBancaria.banco_codigo = this.formulario.controls["banco"].value;
    this.selectedCuentaBancaria.numero_cuenta = this.formulario.controls["numero_cuenta"].value;
    this.selectedCuentaBancaria.observaciones = this.formulario.controls["observaciones"].value;
    this.selectedCuentaBancaria.activo = this.formulario.controls["activo"].value;
    this.refrescarCuentaBancaria(this.selectedCuentaBancaria);
  }

  refrescarCuentaBancaria(cuenta_bancaria: cuenta_bancaria) {
    let self = this;
    var bodyx = cuenta_bancaria;
    delete cuenta_bancaria["__typename"];
    this.client.mutate({
      mutation: gql`
      mutation($entidad: cuenta_bancariaInputType)
      {
        cuenta_bancaria
        {
          guardar(entidad: $entidad) {
            respuesta{
              empresa_rut
              tipo_cuenta_bancaria_codigo
              banco_codigo
              numero_cuenta
              observaciones
              activo
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.cuenta_bancaria.guardar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosCuentaBacarias(), 1000);
        }
      });
  }

  obtenerDatosSegunFiltro(filtro_nombre:string) {
    let self = this;
    self.rut_empresa=self.accesolocalstorage.getRutEmpresa();
    if (filtro_nombre == undefined){
      filtro_nombre="";
    }
    this.client.mutate({
      mutation: gql`
      query ($empresa_rut:Decimal, $filtro:String ){
        cuenta_bancaria{
          obtenerSegunFiltroJoin(empresa_rut:$empresa_rut, filtro:$filtro)
          {
            respuesta
            {
              registros
              {
                empresa_rut
                tipo_cuenta_bancaria_codigo
                nombre_tipo_cuenta
                banco_codigo
                nombre_banco
                numero_cuenta
                observaciones
                activo
              }
            }
          }
        }
      }
      `,
      variables: {
        'empresa_rut': self.rut_empresa,
        'filtro':filtro_nombre
      }
    },
      function (respuesta) {
        self.cuenta_bancariaJoinList = respuesta.data.cuenta_bancaria.obtenerSegunFiltroJoin.respuesta.registros;
      });
  }
  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(cuenta_bancariaJoin: cuenta_bancariaJoin) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(cuenta_bancariaJoin);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
